import React, { useEffect, useState } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  CardTitle,
  Form,
  FormGroup,
  Label,
  Input,
  Button,
  Spinner
} from "reactstrap";

import axios from "axios";
import "../Assets/css/style.css";
import AdminSidebar from "../Partials/adminsidebar";

const DeleteQuestion = () => {

  // ✅ Domains
  const [domains] = useState([
    { id: "1", name: "Content Creation" },
    { id: "2", name: "Sales" },
    { id: "3", name: "Accountant" }
  ]);

  const [selectedDomain, setSelectedDomain] = useState("");
  const [questions, setQuestions] = useState([]);
  const [selectedQuestion, setSelectedQuestion] = useState("");
  const [loading, setLoading] = useState(false);

  // ✅ Load all questions initially
  useEffect(() => {
    fetchQuestions();
  }, []);

  // ✅ Fetch all questions
  const fetchQuestions = async () => {
    try {

      const token = localStorage.getItem("admin_token");

      const res = await axios.get(
        // "http://localhost/qads_interview/question/list.php",
        "https://interview.qads.co.in/qads_interview/question/list.php",
        {
          headers: {
            Authorization: `Bearer ${token}`
          }
        }
      );

      if (res.data.status) {
        setQuestions(res.data.data.questions);
      }

    } catch (error) {
      console.log(error);
    }
  };

  // ✅ Filter questions by domain
  const fetchQuestionsByDomain = async (domainId) => {

    setSelectedDomain(domainId);
    setSelectedQuestion("");

    try {

      const token = localStorage.getItem("admin_token");

      const res = await axios.get(
        // "http://localhost/qads_interview/question/list.php",
        "https://interview.qads.co.in/qads_interview/question/list.php",
        {
          params: { domain_id: domainId },
          headers: {
            Authorization: `Bearer ${token}`
          }
        }
      );

      if (res.data.status) {
        setQuestions(res.data.data.questions);
      }

    } catch (err) {
      console.log(err);
    }
  };

  // ✅ Delete Question
  const handleDelete = async (e) => {

    e.preventDefault();

    if (!selectedQuestion) {
      alert("Please select question");
      return;
    }

    const confirmDelete = window.confirm(
      "Are you sure you want to delete this question?"
    );

    if (!confirmDelete) return;

    setLoading(true);

    try {

      const token = localStorage.getItem("admin_token");

      const response = await axios.post(
        // "http://localhost/qads_interview/question/delete.php",
        "https://interview.qads.co.in/qads_interview/question/delete.php",
        {
          question_id: selectedQuestion
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
          }
        }
      );

      alert(response.data.message);

      // Refresh list after delete
      fetchQuestions();
      setSelectedQuestion("");

    } catch (error) {

      if (error.response) {
        alert(error.response.data.message);
      } else {
        alert("Server error");
      }
    }

    setLoading(false);
  };

  return (
    <div className="delete-page">
      <div style={{ display: "flex" }}>
        <AdminSidebar />

        <div style={{ marginLeft: "250px", width: "100%", padding: "20px" }}>
          <Container fluid>
            <Row className="justify-content-center">
              <Col md="6">
                <Card className="delete-card">
                  <CardBody>

                    <CardTitle className="delete-title">
                      Delete Question
                    </CardTitle>

                    <Form onSubmit={handleDelete}>

                      {/* Domain Filter */}
                      <FormGroup>
                        <Label>Select Domain</Label>

                        <Input
                          type="select"
                          value={selectedDomain}
                          onChange={(e) =>
                            fetchQuestionsByDomain(e.target.value)
                          }
                        >
                          <option value="">All Domains</option>

                          {domains.map(d => (
                            <option key={d.id} value={d.id}>
                              {d.name}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>

                      {/* Question List */}
                      <FormGroup>
                        <Label>Select Question</Label>

                        <Input
                          type="select"
                          value={selectedQuestion}
                          onChange={(e) =>
                            setSelectedQuestion(e.target.value)
                          }
                          required
                        >
                          <option value="">Select Question</option>

                          {questions.map(q => (
                            <option key={q.id} value={q.id}>
                              {q.question.substring(0, 80)}...
                            </option>
                          ))}

                        </Input>
                      </FormGroup>

                      <Button
                        className="delete-btn"
                        block
                        disabled={loading}
                        type="submit"
                      >
                        {loading ? <Spinner size="sm" /> : "Delete Question"}
                      </Button>

                    </Form>

                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
      </div>
    </div>
  );
};

export default DeleteQuestion;